import { getUser_getUserV2 } from 'whatis_gql/src/queries/__generated__/getUser';
import {
  LoginUserMessage,
  LogoutUserMessage,
  UpdateCachedWhatisesMessage,
} from './sharedExtensionMessageTypes';
import * as Sentry from '@sentry/react';

export const broadcastUpdateWhatises = () => {
  const message = {
    type: 'UPDATE_WHATISES',
  } as UpdateCachedWhatisesMessage;

  send(message);
};

export const loginExtensionUser = (user: getUser_getUserV2, token: string) => {
  const loginMessage = {
    type: 'LOGIN_USER',
    token,
  } as LoginUserMessage;

  send(loginMessage);
};

export const logoutExtensionUser = () => {
  const logoutMessage = { type: 'LOGOUT_USER' } as LogoutUserMessage;
  send(logoutMessage);
};

const send = (
  message: LogoutUserMessage | LoginUserMessage | UpdateCachedWhatisesMessage
) => {
  try {
    // Handle logging in multiple extension backends
    const ids = process.env?.VITE_CHROME_EXTENSION_ID;
    // @ts-expect-error compiler unhappy
    ids.split(',').forEach((id) => {
      // TODO: work out what is going on here and why the types aren't working
      // @ts-expect-error compuiler still unhapppy
      window.chrome && chrome?.runtime?.sendMessage(id, message);
    });
  } catch (err) {
    Sentry.captureException(err);
  }
};
